export const PAGE_SIZE = 500;
export const DURATION_DISABLE = 'disable';